import { useEffect, useMemo, useRef, useState } from 'react';
import style from './index.module.scss';
import service from '@/request/service';
import cls from 'classnames';
import { useStore } from '@/store';
import { CodeStateEnum, OrderObjType, PreferCoupon } from '@/types';
import { packCouponPayInfo } from '@/utils';
import { ALERT_TYPE, OrderType } from '@/types';
import { clone, cloneDeep } from 'lodash';
import { Toast } from '../Toast';
import { getIntl } from '@/locales';
import { useEffectDiff } from '@/hooks/useEffectDiff';
import { COUPON_TYPE, getInCouponGroupMap, packCouponList, packGoodsDiscountMap, packTikectDiscountMap } from './const';
import CouponItem from '../CouponItem';
import Button from '../Button';
import { DrawerHeader } from '@/packages';

/**
 @desktop 兑换券的逻辑
  假设我有3个票
  50，60，70
  我现在有一个 70的不可补差的兑换券，优先找自己能兑换的最大的票
  依次类推,
  如果有一个xx元，甚至是0.1元的兑换券，只要是可补差价的，都可以无视上限视为9999999，等于斗地主的王炸，也是优先兑换最大价值的SKU
  总结 每个票的SKU必须有一个能涵盖自己价格且唯一的优惠券
 */
/**
 @desktop 总体的逻辑
    影片订单和卖品订单都是互相独立的订单
    每个订单只能有一个优惠券类型
    前端逻辑：null=>根据后端逻辑,除了兑换券,其他都是一票对一个券
    后端逻辑：每一个票/卖品的sku对应一个优惠券模版
    特殊场景
    1.代金券，必须满多少可用
    2.兑换券，可兑换多少？是否补差价
      可补差价 可选
      不可补差 低于可兑换限度可选
 */
/**
 @desktop 优惠券的类型
 @CASH_COUPON 代金券
 @EXCHANGE_VOUCHER 兑换券
 @ANY_VOUCHER 自定义兑换券
 @REPRICE_COUPON 特惠券
 @DISCOUNT_COUPON 折扣券
 @NONE 无类型
 */

export enum COUPON_USE_TYPE {
  TICKET = 'TICKET',
  GOODS = 'GOODS',
  COMMON = 'COMMON',
}

/**
 * @exchangePolicy 券兑换策略
 * @ONE : 一兑一
 * @MORE : 多兑一
 * @CUSTOM : 自定义兑换规则
 * @exchangeQuantity 自定义兑换券N:1
 */
export enum EXCHANGE_POLICY_ENUM {
  ONE = 'ONE',
  MORE = 'MORE',
  CUSTOM = 'CUSTOM',
}

const CouponModule = ({ coupon, handleClick, disabled, isSeclect, canSeclect, canUseList, exTips }) => {
  // const intl = getIntl();
  useEffect(() => {
    if (coupon.couponType === COUPON_TYPE.EXCHANGE_VOUCHER && isSeclect) {
      // console.log(coupon);
    }
  }, [coupon, isSeclect]);

  const handleClick1 = () => {
    if (!canSeclect) return;
    const curCoupon = clone(coupon);
    handleClick?.({
      ...curCoupon,
      canUseTicket: canUseList.canUseTicket,
      canUseGoods: canUseList.canUseGooods,
    });
  };

  return (
    <>
      <section
        className={cls(style.couponItemContainer, {
          [style.disabled]: disabled || !canSeclect,
          [style.selected]: isSeclect,
        })}
        onClick={handleClick1}
      >
        <CouponItem
          // key={k
          coupon={{ ...coupon, warning: exTips }}
          click={() => { }}
          disable={disabled || !canSeclect}
          select={isSeclect}
        />

        {/* <div className={style.dev}>
          DEV
          <div className={style.info}>
            <div>
              {intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.Threshold', defaultMessage: '门槛:' })}
              {formatCentsToYuan(coupon.limitValue)}
            </div>
            <div>
              {intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.Limit', defaultMessage: '限额:' })}
              {formatCentsToYuan(coupon.discountValue)}
            </div>
            <div>第几张：-{index}</div>
            <div>券码:{coupon.couponCode}</div>
            <div>
              {intl.formatMessage(
                {
                  id: 'iWeb.components.SeclectCoupon.PriceDifferenceCouponcompensateprice',
                  defaultMessage: '可补差价:{couponCompensatePrice}',
                },
                { couponCompensatePrice: coupon.compensatePrice },
              )}
            </div>
            <div>
              {intl.formatMessage(
                {
                  id: 'iWeb.components.SeclectCoupon.SeveralTimesCouponexchangequantity',
                  defaultMessage: '几兑1:{couponExchangeQuantity}',
                },
                { couponExchangeQuantity: coupon.exchangeQuantity },
              )}
            </div>
            <div>
              {intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.Scope', defaultMessage: '作用域:' })}
              {coupon.scope === 'sku'
                ? intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.Item', defaultMessage: '单品' })
                : intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.Order', defaultMessage: '订单' })}
            </div>
            <div>
              {intl.formatMessage({
                id: 'iWeb.components.SeclectCoupon.CanItBeUsedIn',
                defaultMessage: '能否在票订单使用：',
              })}
              {canUseList.canUseInTicket
                ? intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.Yes', defaultMessage: '是' })
                : intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.No', defaultMessage: '否' })}
            </div>
            <div>
              {intl.formatMessage({
                id: 'iWeb.components.SeclectCoupon.CanItBeUsedIn.1',
                defaultMessage: '能否在卖品订单使用：',
              })}
              {canUseList.canUseInGoods
                ? intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.Yes', defaultMessage: '是' })
                : intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.No', defaultMessage: '否' })}
            </div>
          </div>
        </div> */}
      </section>
    </>
  );
};
export default function SeclectCoupon(props) {
  const { coupons: curCoupons, privilegeParams, onClose, onChange } = props; // 租户信息
  const [loading, setLoading] = useState(false);
  const [coupons] = useState(clone(curCoupons));
  const { orderObj, setOrderObj }: { orderObj: OrderObjType;[key: string]: any } = useStore();
  const [canList, setCanList] = useState([] as any[]);
  const [noCanList, setNoCanList] = useState([] as any[]);
  const intl = getIntl();
  const [tabList] = useState([
    {
      id: 1,
      name: intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.Available', defaultMessage: '可用' }),
    },
    {
      id: 2,
      name: intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.Unavailable', defaultMessage: '不可用' }),
    },
  ] as any[]);

  const [activeTab, setActiveTab] = useState(tabList[0]);

  // const orderType = useMemo(() => {
  //   let res: OrderType[] = [];
  //   if (orderObj.seat.seatList.length > 0) {
  //     res.push(OrderType.TICKET);
  //   }
  //   if (orderObj.pos?.goodsParamsJson?.length > 0) {
  //     res.push(OrderType.GOODS);
  //   }
  //   if (res.length === 2) {
  //     return OrderType.MIX;
  //   } else {
  //     return res[0];
  //   }
  // }, [orderObj]);

  // 票订单 的已选的优惠券列表 （限额的 目前是兑换券有使用限制）
  const mapTicketCoupon = useRef(packTikectDiscountMap(orderObj.seat.seatList));
  // 卖品订单 的已选的优惠券列表 （限额的 目前是兑换券有使用限制）
  const mapGoodsCoupon = useRef(packGoodsDiscountMap(orderObj.pos.goodsParamsJson));

  // 票数
  const seatNum = mapTicketCoupon.current.length;
  // 卖品数
  const goodNum = mapGoodsCoupon.current.length;

  // 影片订单的优惠券类型
  const [piaoType, setPiaoType] = useState(COUPON_TYPE.NONE);
  // 卖品订单的优惠券类型
  const [goodType, setGoodType] = useState(COUPON_TYPE.NONE);

  // 影片订单的优惠券模版 //多兑1使用
  const piaoCode = useRef(null);
  // 卖品订单的优惠券模版 //多兑1使用
  const goodCode = useRef(null);

  // 影片订单的已选的优惠券列表
  const [ticketList, setTicketList] = useState([] as any[]);
  // 卖品订单的已选的优惠券列表
  const [goodstList, setGoodstList] = useState([] as any[]);

  const [up, setUp] = useState(0);

  // 票订单 总原价
  const originalTicketTotalPrice = Number(orderObj.payInfo?.originalTicketTotalPrice);

  // 卖品订单 总原价
  const originalGoodsTotalPrice = Number(orderObj.payInfo?.originalGoodsTotalPrice);

  const couponList = useMemo(() => {
    if (activeTab.id === 1) {
      return packCouponList(canList);
    } else {
      return packCouponList(noCanList);
    }
  }, [activeTab, canList, noCanList]);

  useEffect(() => {
    console.log('[dev]看看-监听couponList的变化:', couponList);
  }, [couponList]);

  useEffect(() => {
    // 洗券数据
    const _al: any[] = [];
    const _dl: any[] = [];
    const _prefer: any[] = [];
    coupons.forEach((item) => {
      if (item.state === 'USEFUL') {
        _al.push(item);
      } else {
        _dl.push(item);
      }
      if (item.isPrefer === 'Y') {
        _prefer.push(item);
      }
    });
    setCanList(_al);
    setNoCanList(_dl);
  }, [coupons]);

  // 处理点击函数
  const handleCouponClick = (item) => {
    if (activeTab.id === 2) {
      return;
    }
    // 如果是已选的直接剔除
    if (ticketList.some((i) => i.couponCode === item.couponCode)) {
      setTicketList(ticketList.filter((i) => i.couponCode !== item.couponCode));
      return;
    }
    if (goodstList.some((i) => i.couponCode === item.couponCode)) {
      setGoodstList(goodstList.filter((i) => i.couponCode !== item.couponCode));
      return;
    }
    const setGood = (type = OrderType.GOODS) => {
      setGoodstList([
        ...goodstList,
        {
          ...item,
          useSetType: type,
        },
      ]);
    };
    const setTicket = (type = OrderType.TICKET) => {
      setTicketList([
        ...ticketList,
        {
          ...item,
          useSetType: type,
        },
      ]);
    };
    const { canUseInTicket, canUseInGoods } =
      couponCanUseMap[couponList.findIndex((i) => i.couponCode === item.couponCode)];
    if (canUseInTicket && canUseInGoods) {
      Toast({
        type: ALERT_TYPE.DIALOG,
        content: intl.formatMessage({
          id: 'iWeb.components.SeclectCoupon.SelectToActOnThat',
          defaultMessage: '选择作用于那个订单',
        }),
        confirmText: intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.ShadowTicket', defaultMessage: '影票' }),
        confirm() {
          setTicket(OrderType.TICKET);
        },
        cancelText: intl.formatMessage({
          id: 'iWeb.components.SeclectCoupon.SellingProducts',
          defaultMessage: '卖品',
        }),
        cancel() {
          setGood(OrderType.GOODS);
        },
      });
      return;
    }
    if (canUseInTicket) {
      setTicket(OrderType.TICKET);
    }
    if (canUseInGoods) {
      setGood(OrderType.GOODS);
    }
  };

  useEffectDiff(
    (n, o) => {
      if (ticketList.length === 0) {
        setPiaoType(COUPON_TYPE.NONE);
        piaoCode.current = null;
      }
      if (ticketList.length === 1) {
        setPiaoType(ticketList[0].couponType);
        piaoCode.current = ticketList[0].templateCode;
      }
      // 创建一个新数组存储差集
      let difference = [];
      difference = n.filter((obj1) => !o.some((obj2) => obj2.couponCode === obj1.couponCode));
      difference = difference.concat(o.filter((obj2) => !n.some((obj1) => obj1.couponCode === obj2.couponCode)));
      const changeCoupon = difference[0] as any;
      // 拿到多出来或少掉的优惠券
      if (changeCoupon) {
        // 找到 可涵盖的sku的索引
        const index = getDIS({ coupon: changeCoupon, type: 'ticket' });
        if (n.length > o.length && index > -1) {
          mapTicketCoupon.current = mapTicketCoupon.current.map((item, i) => {
            if (i === index) {
              item.useCoupon.push(changeCoupon.couponCode);
            }
            return item;
          });
        }
        if (n.length < o.length) {
          mapTicketCoupon.current = mapTicketCoupon.current.map((item) => {
            item.useCoupon = item.useCoupon.filter((i) => i !== changeCoupon.couponCode);
            return item;
          });
        }
      }
      setUp(up + 1);
    },
    [ticketList],
  );

  useEffectDiff(
    (n, o) => {
      if (goodstList.length === 0) {
        setGoodType(COUPON_TYPE.NONE);
        goodCode.current = null;
      }
      if (goodstList.length === 1) {
        setGoodType(goodstList[0].couponType);
        goodCode.current = goodstList[0].templateCode;
      }
      // 创建一个新数组存储差集
      let difference = [];
      difference = n.filter((obj1) => !o.some((obj2) => obj2.couponCode === obj1.couponCode));
      difference = difference.concat(o.filter((obj2) => !n.some((obj1) => obj1.couponCode === obj2.couponCode)));
      const changeCoupon = difference[0] as any;
      // 拿到多出来或少掉的优惠券
      if (changeCoupon) {
        // 找到 可涵盖的sku的索引
        const index = getDIS({ coupon: changeCoupon, type: 'goods' });
        if (n.length > o.length && index > -1) {
          mapGoodsCoupon.current = mapGoodsCoupon.current.map((item, i) => {
            if (i === index) {
              item.useCoupon.push(changeCoupon.couponCode);
            }
            return item;
          });
        }
        if (n.length < o.length) {
          mapGoodsCoupon.current = mapGoodsCoupon.current.map((item) => {
            item.useCoupon = item.useCoupon.filter((i) => i !== changeCoupon.couponCode);
            return item;
          });
        }
      }
      setUp(up + 1);
    },
    [goodstList],
  );

  // 获取 当前的票或者卖品，是否有能涵盖的sku,返回索引
  const getDIS = (props: { coupon: any; type: 'ticket' | 'goods' }) => {
    const { coupon, type } = props;
    const {
      discountValue,
      // couponType,
      compensatePrice,
      exchangeQuantity,
      goodsNameList,
    } = coupon;
    const discount = compensatePrice === 'Y' ? Number.MAX_SAFE_INTEGER : discountValue;
    if (type === 'ticket') {
      const list = cloneDeep(mapTicketCoupon.current);
      // 找一个当前限额能打过的，且没有被其他兑换券占据
      const id = list.findIndex((item) => {
        return item.price <= discount && item.useCoupon.length < exchangeQuantity;
      });
      return id;
    }

    if (type === 'goods') {
      const list = cloneDeep(mapGoodsCoupon.current);
      let hasFilterGoods = false;
      const filterList = goodsNameList?.[0]?.couponGoodList?.map(item => item.goodsCode) || [];
      if (filterList.length > 0) {
        hasFilterGoods = true;
      }
      if (hasFilterGoods && !(list.findIndex(i => { return filterList.includes(i.goodsId); }) > -1)) {
        // 找不到对应的商品
        return -999;
      }

      // 找一个当前限额能打过的，且没有被其他兑换券占据
      const id = list.findIndex((item) => {
        return item.price <= discount && item.useCoupon.length < exchangeQuantity && (!hasFilterGoods || (hasFilterGoods && filterList.includes(item.goodsId)));
      });
      return id;
    }
    return -999;
  };

  // const getTipText = (coupon) => {
  //   const temp = [...ticketList, ...goodstList].filter((i) => i.couponCode === coupon.couponCode)?.[0];
  //   if (!temp) {
  //     return '';
  //   }
  //   if (temp.useType === COUPON_USE_TYPE.COMMON) {
  //     return temp.useSetType;
  //   }
  // };

  const canUseInTicket = ({ coupon, index }) => {
    console.log('[dev]看看-coupon:', '影片:', coupon, `第${index}个`);
    const {
      couponType,
      useType,
      couponCode,
      limitValue,
      // discountValue,
      // compensatePrice,
      templateCode,
      scope,
      exchangeQuantity,
      isOneTemplate,
    } = coupon;
    if (useType === COUPON_USE_TYPE.TICKET || useType === COUPON_USE_TYPE.COMMON) {
      // 已选的肯定可选
      if ([...ticketList].some((i) => i.couponCode === couponCode)) {
        return true;
      }
      // 看看是否在组合内
      const zuhe = [...new Set([piaoType, couponType])].filter((item) => item !== COUPON_TYPE.NONE);
      const isIn = getInCouponGroupMap(zuhe);
      // 不在互斥叠加组合内 就不可选
      if (!isIn) {
        // console.log('[dev]看看-影片zuhe:', zuhe);
        // console.log('[dev]看看-影片不在互斥叠加组合内 就不可选', index);
        return false;
      }
      // 低消
      // 当前金额低于低消就不可选
      if (limitValue > originalTicketTotalPrice) {
        // console.log('[dev]看看-影片当前金额低于低消就不可选', index);
        return false;
      }

      // 限额
      // 看看有没有一张票我可以限额超过他的，没有就不可选
      const hasDiscountValue = getDIS({ coupon, type: 'ticket' }) > -1;
      if (!hasDiscountValue) {
        // console.log('[dev]看看- 影片看看有没有一张票我可以限额超过他的，没有就不可选', index);
        return false;
      }

      // 作用范围&&几兑1个
      switch (scope) {
        case 'order':
          // 如果是作用订单的话
          // 几个券兑换一个订单,
          if (ticketList.length >= exchangeQuantity) {
            // console.log('[dev]看看-影片几个券兑换一个订单,', index);
            return false;
          }
          break;
        case 'sku':
          // 如果是作用单品的话
          // 几个券兑换一个订单,
          if (ticketList.length >= exchangeQuantity * seatNum) {
            // console.log('[dev]看看-影片几个券兑换一个订单,', index);
            return false;
          }
          break;
        default:
          break;
      }

      // 是否券模版需要相同
      if (isOneTemplate) {
        if (templateCode !== piaoCode.current && piaoCode.current && ticketList.length > 0) {
          // console.log('[dev]看看-影片是否券模版需要相同,', index);
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  };
  const canUseInGoods = ({ coupon, index }) => {
    // if (index === 0) {
    //   debugger
    // }
    // console.log('[dev]看看-mapGoodsCoupon.current:', mapGoodsCoupon.current);
    console.log('[dev]看看-coupon:', '卖品:', coupon, `第${index}个`);
    const {
      couponType,
      useType,
      couponCode,
      limitValue,
      // discountValue,
      // compensatePrice,
      templateCode,
      scope,
      exchangeQuantity,
      isOneTemplate,
    } = coupon;
    if (useType === COUPON_USE_TYPE.GOODS || useType === COUPON_USE_TYPE.COMMON) {
      // 已选的肯定可选
      if ([...goodstList].some((i) => i.couponCode === couponCode)) {
        return true;
      }
      // 看看是否在组合内
      const zuhe = [...new Set([goodType, couponType])].filter((item) => item !== COUPON_TYPE.NONE);
      const isIn = getInCouponGroupMap(zuhe);
      // 不在互斥叠加组合内 就不可选
      if (!isIn) {
        // console.log('[dev]看看-卖品zuhe:', zuhe);
        // console.log('[dev]看看-卖品不在互斥叠加组合内 就不可选', index);
        return false;
      }
      // 低消
      // 当前金额低于低消就不可选
      console.log('[dev]看看-originalGoodsTotalPrice:', index, originalGoodsTotalPrice);
      if (limitValue > originalGoodsTotalPrice) {
        // console.log('[dev]看看-卖品当前金额低于低消就不可选', index);
        return false;
      }

      // 限额
      // 看看有没有一张票我可以限额超过他的，没有就不可选
      const hasDiscountValue = getDIS({ coupon, type: 'goods' }) > -1;
      if (!hasDiscountValue) {
        // console.log('[dev]看看- 卖品看看有没有一个卖品我可以限额超过他的，没有就不可选', index);
        return false;
      }

      // 作用范围&&几兑1个
      switch (scope) {
        case 'order':
          // 如果是作用订单的话
          // 几个券兑换一个订单,
          if (goodstList.length >= exchangeQuantity) {
            // console.log('[dev]卖品看看-几个券兑换一个订单,', index);
            return false;
          }
          break;
        case 'sku':
          // 如果是作用单品的话
          // 几个券兑换一个订单,
          if (goodstList.length * exchangeQuantity >= goodNum) {
            // console.log('[dev]看看-卖品几个券兑换一个订单,', index);
            return false;
          }
          break;
        default:
          break;
      }

      // 是否券模版需要相同
      if (isOneTemplate) {
        if (templateCode !== piaoCode.current && piaoCode.current && goodstList.length > 0) {
          // console.log('[dev]看看-卖品是否券模版需要相同,', index);
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  };
  const couponCanUseMap = useMemo(() => {
    return couponList.map((item, index) => {
      return {
        canUseInTicket: canUseInTicket({ coupon: item, index }),
        canUseInGoods: canUseInGoods({ coupon: item, index }),
      };
    });
  }, [couponList, goodstList, ticketList, up]);

  const next = async () => {
    setLoading(true);
    const list: PreferCoupon[] = [...ticketList, ...goodstList];
    const values = list.map((item) => item.couponCode);

    // 通用/特定
    let couponType = list?.map((item) => {
      const couponCode = values.find((code) => code == item.couponCode);
      const couponObj =
        item.useType === COUPON_USE_TYPE.COMMON || item.concreteProductType === COUPON_USE_TYPE.COMMON
          ? { couponCode, concreteProductType: item.useSetType }
          : { couponCode };
      return couponObj;
    });
    let couponCodes = values?.join('|');
    let commonCouponJson = JSON.stringify(couponType);
    service
      .getPayDiscountPrice({
        ...privilegeParams,
        couponCodes,
        commonCouponJson,
      })
      .then((res) => {
        if (res.result?.bizCode === CodeStateEnum.SUCCESS) {
          if (res.result.bizValue?.privilegeTotalPrice) {
            orderObj.payInfo = packCouponPayInfo(res.result.bizValue, orderObj.payInfo, {
              couponList: list,
            });
            setOrderObj(orderObj);
            // 外部展示优惠价格
            onChange?.(orderObj.payInfo?.priceDiff);
            onClose();
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const clear = () => {
    setTicketList([]);
    setGoodstList([]);
    setUp(up + 1);
  };

  const exTips = useMemo(() => {
    return couponList.map((item) => {
      const code = item.couponCode;
      let tips = '';
      const setUseTypeEnum = {
        TICKET: intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.ShadowTicket', defaultMessage: '影票' }),
        GOODS: intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.SellingProducts', defaultMessage: '卖品' }),
      };

      if (item.useType === COUPON_USE_TYPE.COMMON && ticketList.findIndex((i) => i.couponCode === code) > -1) {
        tips = `${intl.formatMessage({ id: 'iWeb.pages.coupon.selectTips', defaultMessage: '已选择抵扣' })}${setUseTypeEnum['TICKET']}`;
      }
      if (item.useType === COUPON_USE_TYPE.COMMON && goodstList.findIndex((i) => i.couponCode === code) > -1) {
        tips = `${intl.formatMessage({ id: 'iWeb.pages.coupon.selectTips', defaultMessage: '已选择抵扣' })}${setUseTypeEnum['GOODS']}`;
      }
      return tips;
    });
  }, [couponList, goodstList, ticketList]);

  return (
    <div className={style.container}>
      <div className={style.header}>
        <DrawerHeader title={intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.SelectCoupons', defaultMessage: '选择优惠券' })} onClose={onClose} onCloseAll={onClose} />
      </div>

      <div className={style.tabs}>
        {tabList.map((item) => {
          return (
            <div
              className={cls(style.tabItem, item.id === activeTab.id ? style.active : null)}
              onClick={() => {
                setActiveTab(item);
              }}
            >
              {item.name}
              <span className={style.numTag}>{item.id === 1 ? canList.length : noCanList.length}</span>
            </div>
          );
        })}
      </div>
      <div className={style.couponList}>
        {couponList.map((item, index) => {
          return (
            <CouponModule
              coupon={0 || item}
              handleClick={handleCouponClick}
              disabled={activeTab.id === 2}
              key={item.couponCode}
              isSeclect={[...ticketList, ...goodstList].some((i) => i.couponCode === item.couponCode)}
              canSeclect={couponCanUseMap[index].canUseInTicket || couponCanUseMap[index].canUseInGoods}
              index={index}
              canUseList={couponCanUseMap[index]}
              exTips={exTips[index] ?? ''}
            />
          );
        })}
      </div>
      <div className={style.footer}>
        <Button
          className={cls(style.btn)}
          disabled={!ticketList.length && !goodstList.length}
          btnText={intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.Clear', defaultMessage: '清空' })}
          onClick={clear}
          type="line"
        />

        <Button
          className={cls(style.btn)}
          disabled={!ticketList.length && !goodstList.length}
          onClick={next}
          loading={loading}
        />
      </div>
    </div>
  );
}
